import _ from "lodash";

export const PluginDoughnatLabelInside = {
  beforeDraw: function(chart) {
    let width = chart.chart.width,
      height = chart.chart.height,
      ctx = chart.chart.ctx,
      type = chart.config.type;

    if (
      type === "doughnut" &&
      [
        "NUMBER_OF_UNIQUE_USERS_BY_PLATFORM",
        "UNCOMPLETED_REQUESTS_IN_TOTAL_BY_PLATFORM",
        "NUMBER_OF_UNIQUE_SESSIONS_BY_PLATFORM",
        "LEX_PLATFORM_USAGE"
      ].includes(chart.canvas.id)
    ) {
      let percent = sum(chart.config.data.datasets[0].data);
      // (chart.config.data.datasets[0].data[0] ? chart.config.data.datasets[0].data[0] : 0) +
      // (chart.config.data.datasets[0].data[1] ? chart.config.data.datasets[0].data[1] : 0);
      let oldFill = ctx.fillStyle;
      let fontSize = ((height - chart.chartArea.top) / 100).toFixed(2);

      ctx.restore();
      ctx.font = fontSize + "em sans-serif";
      ctx.textBaseline = "middle";

      let text = "Σ = " + percent,
        textX = Math.round((width - ctx.measureText(text).width) / 2),
        textY = (height + chart.chartArea.top) / 2;

      ctx.fillStyle = "gray";
      ctx.fillText(
        text,
        chart.canvas.id !== "LEX_PLATFORM_USAGE"
          ? textX
          : textX - _.get(chart, "chart.legend.columnWidths[0]", -10) / 2 - 5,
        textY
      );
      ctx.fillStyle = oldFill;
      ctx.save();
    }
  }
};

function sum(input) {
  let total = 0;
  for (let idx = 0; idx <= input.length - 1; idx++) {
    total += input[idx];
  }
  return total;
}
